module.exports = __webpack_public_path__ + "static/media/path3.e62d30e8.png";